<template>
  <div class="game-container">
    <div class="box">
      <img :src="ImageUrl" />
      <div class="points">
        <div
          class="point"
          v-for="(p, i) in initData.points"
          :key="'point_' + i"
          :style="{ left: p.pos.x + 'px', top: +p.pos.y + 'px' }"
          @mouseover="showUpHide(p, true)"
          @mouseleave="showUpHide(p, false)"
        ></div>
        <div
          v-for="(p, i) in initData.points"
          :id="p.id + '_' + i"
          :key="p.id"
          :style="{ left: p.posElem.x + 'px', top: +p.posElem.y + 'px' }"
          :class="['img-elem', { fade: !initData.points[i].show }]"
        >
          <img :src="p.src" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'mp-mendelejew',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
    };
  },
  beforeMount() {
    this.newGame();
  },
  mounted() {},
  methods: {
    newGame() {
      this.initData = this.startGameConfig;
      this.initData.points.forEach(function(p) {
        p.show = false;
      });
    },
    showUpHide(a, flg) {
      this.initData.points.forEach(function(p) {
        p.show = false;
      });
      a.show = flg;
      this.$forceUpdate();
    },
  },
  computed: {
    ImageUrl() {
      return this.startGameConfig.bgrSets.imagePath;
    },
  },
  watch: {},
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 120px 150px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.box {
  background-repeat: no-repeat;
  position: relative;
  margin: 0;
  display: inline-block;
  overflow: hidden;
}

.box img {
  max-width: 100%;
  max-height: 100%;
  height: inherit !important;
}

.points {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.point {
  position: absolute;
  border-radius: 10%;
  z-index: 2;
  width: 75px;
  height: 75px;
  cursor: pointer;
}

.img-elem {
  margin-top: 12px;
  position: absolute;
  height: 780px;
  opacity: 1;
  transition: opacity 1s;
}

.fade {
  opacity: 0;
}
</style>
